var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserName(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4004 9.19922H7.59961C4.51172 9.19922 2 11.7129 2 14.8008V17.2012C2 18.5254 3.07617 19.6016 4.40039 19.6016H15.5996C16.9238 19.6016 18 18.5254 18 17.2012V14.8008C18 11.7129 15.4883 9.19922 12.4004 9.19922ZM16.4004 17.1992C16.4004 17.6406 16.041 18 15.5996 18H4.40039C3.95898 18 3.59961 17.6406 3.59961 17.1992V14.8008C3.59961 12.5957 5.39453 10.8008 7.59961 10.8008H12.4004C14.6055 10.8008 16.4004 12.5957 16.4004 14.8008V17.1992ZM10 8.40039C12.209 8.40039 14 6.60938 14 4.40039C14 2.19141 12.209 0.400391 10 0.400391C7.79102 0.400391 6 2.19141 6 4.40039C6 6.60938 7.79102 8.40039 10 8.40039ZM10 2C11.3242 2 12.4004 3.07617 12.4004 4.40039C12.4004 5.72461 11.3242 6.80078 10 6.80078C8.67578 6.80078 7.59961 5.72266 7.59961 4.40039C7.59961 3.07812 8.67578 2 10 2Z",
    fill: "#8F9AAF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserName);
export default __webpack_public_path__ + "static/media/user-name.e0cb48af0ddeb4d6923313edfe7917b8.svg";
export { ForwardRef as ReactComponent };